import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.error.cause.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState, useEffect } from 'react';
import moize from 'moize';
import { v4 as uuidv4 } from 'uuid';
import { VISIBLE_SLIDES_BREAKPOINT_1, VISIBLE_SLIDES_BREAKPOINT_2, CAROUSEL_BREAKPOINT_1, CAROUSEL_BREAKPOINT_2, MEDIA_QUERY_MATCH } from './constants';
import debounce from 'lodash.debounce';
var getSlideKey = moize(uuidv4, {
  profileName: 'getSlideKey'
});
var getVisibleSlidesArray = function getVisibleSlidesArray(visibleSlides) {
  return Array.isArray(visibleSlides) ? visibleSlides : [VISIBLE_SLIDES_BREAKPOINT_1, VISIBLE_SLIDES_BREAKPOINT_2, visibleSlides];
};
var getVisibleSlides = function getVisibleSlides(visibleSlides, windowWidth) {
  return windowWidth < CAROUSEL_BREAKPOINT_1 ? visibleSlides[0] : windowWidth < CAROUSEL_BREAKPOINT_2 ? visibleSlides[1] : visibleSlides[2];
};
var useResponsiveVisibleSlides = function useResponsiveVisibleSlides(visibleSlides) {
  var _useState = useState(window.innerWidth),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var handleResize = function handleResize() {
    setWidth(window.innerWidth);
  };

  // Debounce to avoid the function fire multiple times
  var handleResizeDebounced = debounce(handleResize, 250);
  useEffect(function () {
    var media;
    try {
      media = window.matchMedia(MEDIA_QUERY_MATCH);
      media.addEventListener('change', handleResizeDebounced);
    } catch (_unused) {
      window.addEventListener('resize', handleResizeDebounced);
    }
    return function () {
      var _media;
      if ((_media = media) !== null && _media !== void 0 && _media.removeEventListener) {
        media.removeEventListener('change', handleResizeDebounced);
      } else {
        window.removeEventListener('resize', handleResizeDebounced);
      }
    };
  });
  return {
    responsiveVisibleSlides: getVisibleSlides(visibleSlides, width),
    browserWidth: width
  };
};

//This is to keep consistant with previous version.
//We should make a major version release that will allow more breakpoints
var getMobileVisibleSlidesArray = function getMobileVisibleSlidesArray(visibleSlides) {
  return [visibleSlides[0], null, visibleSlides[1]];
};
var getMobileVisibleSlides = function getMobileVisibleSlides(visibleSlides) {
  return Array.isArray(visibleSlides) ? getMobileVisibleSlidesArray(visibleSlides) : visibleSlides;
};
export { getSlideKey, getVisibleSlidesArray, useResponsiveVisibleSlides, getMobileVisibleSlides };